import * as React from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import Grid from "@mui/material/Unstable_Grid2";
import CancelButton from "../buttons/CancelButton";
import MainButton from "../buttons/MainButton";
import moment from 'moment';
import { getApiURL } from "../../util/ApiBase";
import { GoToThanks } from '../../util/NavigatePage';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: 350, md: 400 },
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function TransitionsModal(props) {
  const navigate = useNavigate()
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const display_id = searchParams.get('display_id');


  const onSubmit = async () => {
    console.log(moment().format("YYYY-MM-DDT0h:mm:ss"));

    const saveNote = {
      method: 'PUT',
      headers: {
        "Content-Type": 'application/json'
      },
      body: JSON.stringify({
        "id_QUESTIONNAIRE": props.questionnaireId,
        "submitDateTime": moment().format("YYYY-MM-DDThh:mm:ss"),
        "note": props.note
      })
    };

    await fetch(getApiURL('/submitQuestionnaire/'), saveNote)
      .then((res) => res.json())
      .then((response) => {
        console.log(response);
        GoToThanks(navigate, display_id);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={props.open}
        onClose={props.handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={props.open}>
          <Box sx={style}>
            <Box bgcolor={"cardHeaderColor.main"} height={"50px"} borderRadius={1} display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}>
              <Typography id="transition-modal-title" variant="h6" component="h2">
                確認
              </Typography>
            </Box>
            <Box mt={5}>
              <Typography id="transition-modal-description">
                回答を送信するとこれ以降変更ができなくなります。<br />
                送信しますか？
              </Typography>
            </Box>
            <Box bgcolor={"cardFooterColor.main"} borderRadius={1} mt={5} px={{ xs: 2, md: 3 }} py={2}>
              <Grid container justifyContent="space-between">
                <Grid item>
                  <CancelButton onClick={props.handleClose} />
                </Grid>
                <Grid item>
                  <MainButton onClick={() => onSubmit()} text={"回答を送信"} />
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
